import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from '@fortawesome/pro-light-svg-icons';

class AvgRetailRow extends React.PureComponent {
  handleChange = ({ target: { value } }) => {
    this.updatePriceMap(value);
  };

  handleClear = () => {
    this.updatePriceMap();
  };

  updatePriceMap = (value) => {
    const {
      updateTheme,
      dosage,
      avgRetailPrices,
      year,
    } = this.props;

    const prices = {
      ...avgRetailPrices,
      [year]: {
        ...avgRetailPrices[year],
        [dosage]: value,
      },
    };
    updateTheme('avgRetailPrices', prices);
  };

  render() {
    const {
      dosage,
      avgRetailPrices,
      label,
      year,
    } = this.props;

    return (
      <Row className="mb-1">
        <Col className="text-muted">{label}</Col>
        <Col className="d-flex align-items-center" xs="6">
          <InputGroup size="sm">
            <Input
              value={avgRetailPrices[year][dosage] || ''}
              onChange={this.handleChange}
              type="number"
            />
            <InputGroupText>
              <Button onClick={this.handleClear} color="lightred" outline>
                <FontAwesomeIcon icon={faBackspace} />
              </Button>
            </InputGroupText>
          </InputGroup>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  avgRetailPrices: state.sites.values?.avgRetailPrices ?? {},
});

const mapDispatchToProps = {
  updateTheme: (id, value) => ({ type: 'EDIT_SITE_THEME', id, value }),
};

export default connect(mapStateToProps, mapDispatchToProps)(AvgRetailRow);
